import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import Assureurs from '../components/Assureurs.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // jobs : .o-entry__item data-lieux="item1,item2" data-categories="Cat1,Cat2"
        // filter lieux items : a.js-lieux select.js-select-lieux a.js-lieux-all
        // filter category items: a.js-cat select.js-select-cat

        this.el.querySelectorAll('a.js-lieux').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                let term = el.textContent;
                this.filterJobs(term, 'lieux');
            });
        });

        this.el.querySelectorAll('a.js-cat').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                let term = el.textContent;
                this.filterJobs(term, 'categories');
            });
        });

        this.el.querySelector('.js-lieux-all').addEventListener('click', (e) => {
            e.preventDefault();
            this.el.querySelectorAll('.o-entry__item').forEach((el) => {
                el.classList.remove('hidden');
            });
            let noItems = this.el.querySelector('.o-entry__no-items');
            noItems.classList.add('hidden');
        });

        this.el.querySelector('select.js-select-lieux').addEventListener('change', (e) => {
            let term = e.target.value;
            this.filterJobs(term, 'lieux');
        });

        this.el.querySelector('select.js-select-cat').addEventListener('change', (e) => {
            let term = e.target.value;
            this.filterJobs(term, 'categories');
        });
    }

    filterJobs(term, type) {
        this.el.querySelectorAll('.o-entry__item').forEach((el) => {
            let terms = el.getAttribute(`data-${type}`).split(',');
            if (terms.includes(term)) {
                el.classList.remove('hidden');
            } else {
                el.classList.add('hidden');
            }
        });

        // if no items are visible, show a message
        let visibleItems = this.el.querySelectorAll('.o-entry__item:not(.hidden)');
        let noItems = this.el.querySelector('.o-entry__no-items');
        if (visibleItems.length === 0) {
            noItems.classList.remove('hidden');
        } else {
            noItems.classList.add('hidden');
        }
    }
}
